<template>
  <div class="loading-indicator">
    <div :class="['block', 'block-1', blockClass]"></div>
    <div :class="['block', 'block-2', blockClass]"></div>
    <div :class="['block', 'block-3', blockClass]"></div>
  </div>
</template>

<script>
export default {
  props: {
    lightness: {
      type: Number,
      default: 50,
    },
  },
  computed: {
    blockClass() {
      return `lightness-${this.lightness}`;
    },
  },
};
</script>

<style scoped>
.loading-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px; /* 方块之间的间距 */
}

.block {
  width: 2px;
  height: 2px;
  background-color: #e0e0e0;
}

.block-1 {
  animation: pulse 2s infinite 0.2s;
}

.block-2 {
  animation: pulse 2s infinite 0.4s;
}

.block-3 {
  animation: pulse 2s infinite 0.6s;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
}

/* 动态设置颜色深浅 */
.lightness-50 {
  filter: brightness(50%);
}

.lightness-75 {
  filter: brightness(75%);
}

.lightness-100 {
  filter: brightness(100%);
}

/* 可以根据需要添加更多的 lightness 类 */
</style>
